module.exports = __webpack_public_path__ + "static/media/Yunjin.974d7a34.png";